import { createFindById, createFindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getGroupLinkField` selector.
 */
export const findById = createFindById('groupLinks');
/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getGroupLinkFieldThrows` selector.
 */
export const findByIdThrows = createFindByIdThrows('groupLinks');
